export default __webpack_public_path__ + "static/media/eth.7f2a4365.svg";